export default __webpack_public_path__ + "static/media/method1.201c08a8.png";